module.exports = __webpack_public_path__ + "img/blockables-instructions-2.8d6ff903.png";